import { NgModule } from '@angular/core';
import { InformationCollectorByPaymentService } from '../information-collector-by-payment/collector/services/information-collector-by-payment.service';
import { AwbSubscriptionService } from './services/awb-subscription.service';
import { SubscriptionComponent } from './subscription/subscription.component';

@NgModule({
    imports: [SubscriptionComponent],

    providers: [AwbSubscriptionService, InformationCollectorByPaymentService],
})
export class AWBSubscriptionModule {}
